const scrollView = {
  /**
   * 设置题目所属的DOM元素
   * @param {string} id
   * @param {element} element
   */
  setQuestionElement (id, element) {
    this.indexes[id].element = element
  },

  /**
   * 设置题目的DOM元素
   * @param {string} id
   */
  getQuestionElement (id) {
    return this.indexes[id].element
  },

  /**
   * 题目滚动屏幕中
   * @param {string} id
   */
  scrollQuestionIntoView (id) {
    this.getQuestionElement(id).scrollIntoView()
  }

}

export default scrollView



// WEBPACK FOOTER //
// ./src/views/question-review/lib/scroll-view.js